import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { BetInfoModel } from '@rush-shared/models'
import { BetService, RushGameService } from '@rush-shared/services'
import { BetTypeEnum } from '@shared/enums'

@Component({
  selector: 'app-current-bets',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './current-bets.component.html',
  styleUrl: './current-bets.component.sass',
})
export class CurrentBetsComponent {
  betType = BetTypeEnum

  constructor(
    public _betService: BetService,
    private _rushGameService: RushGameService,
  ) {}

  ngOnInit() {}

  getBetTotal(betTypeId: BetTypeEnum): number {
    return (
      this._rushGameService.playerData$.value.betTotals.find((i) => i.betTypeId === betTypeId)?.total || 0
    )
  }
}
